import React, { Component, Fragment } from 'react'
import Select  from 'react-select'
import { StyledInput } from './styled-input.style'
import Browser from '../../../services/Browser'

export class LightSelectSearchBar extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			value,
			onChange,
			options,
			placeholder,
			noOptionsMessage,
			disabled,
			handleBlur,
			defaultInputValue,
			isClearable,
			shadow,
			noBorder,
			maxMenuHeight,
			onInputChange,
			inputValue,
			styles
		} = this.props
		const isIE = Browser.isIE()
		return (
			<StyledInput shadow={shadow} noBorder={noBorder}>
				<Select
					value={value}
					isClearable={isClearable}
					defaultInputValue={defaultInputValue}
					onBlur={handleBlur}
					onChange={onChange}
					options={options}
					isDisabled={disabled}
					styles={styles}
					isSearchable={true}
					maxMenuHeight={maxMenuHeight || 300}
					className={'select'}
					loadingMessage={() => 'Carregando ...'}
					menuPosition={isIE ? 'fixed' : 'absolute'}
					style={{ zIndex: 10 }}
					backspaceRemovesValue={false}
					menuPortalTarget={document.body}
					placeholder={placeholder}
					noOptionsMessage={() => (
						<div style={{ fontSize: '16px', cursor: 'default' }}>
							{noOptionsMessage || 'Nenhuma opção para pesquisa'}
						</div>
					)}
					onInputChange={onInputChange}
					inputValue={inputValue}
				/>
			</StyledInput>
		)
	}
}
